/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import ReactSVG from 'react-svg';
import { HeaderEl } from './';

export const Header: React.FC = () => (
  <HeaderEl>
    <ReactSVG path="./assets/blend-header-white.svg" />
  </HeaderEl>
);
